(function () {
  document.querySelectorAll('.sticky-atc').forEach(function (bar) {
    var form = bar.closest('form');
    if (!form) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
          });
        },
        { rootMargin: '0px 0px -70% 0px' }
      );
      observer.observe(form);
    }

    // Keep the sticky bar's price in sync with variant changes in the same form.
    form.addEventListener('change', function (event) {
      if (!event.target.matches('input[name="id"]')) return;
      // Sense's own variant-picker JS updates the on-page price synchronously first.
      var priceEl = form.querySelector('.price .price-item--regular, .price .price-item--sale, .price');
      var priceText = priceEl ? priceEl.textContent.trim() : '';
      if (!priceText) return;
      bar.querySelectorAll('[data-sticky-atc-price]').forEach(function (el) {
        el.textContent = priceText;
      });
    });
  });
})();
